import { render, staticRenderFns } from "./Tipo.vue?vue&type=template&id=4254fec0"
import script from "./Tipo.vue?vue&type=script&lang=ts"
export * from "./Tipo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports